import React from 'react';
import Empty from '@/assets/icons/events/noevents.svg';
import { DefaultContainer, ImageWrapper, MessageText } from './styled';

interface EmptyStateProps {
  message?: string;
  layout?: 'column' | 'row';
}

const EmptyDataStateMessage = ({
  message = 'Sin Resultados',
  layout = 'column'
}: EmptyStateProps) => (
  <DefaultContainer layout={layout}>
    <ImageWrapper>
      <img src={Empty} alt="empty" />
    </ImageWrapper>
    <MessageText>{message}</MessageText>
  </DefaultContainer>
);

export default EmptyDataStateMessage;
